import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const HeroSection = ({ onBookClick, onQuoteClick }) => {
  const trustBadges = [
    "Experienced Cleaning Professionals",
    "Transparent Pricing",
    "Flexible Scheduling",
  ];

  return (
    <section
      id="hero"
      className="hero-gradient pt-24 pb-16 md:pt-32 md:pb-24"
      data-testid="hero-section"
    >
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="text-left animate-fade-in-up">
            <span className="inline-block px-4 py-2 bg-sky-100 text-sky-700 rounded-full text-sm font-medium mb-6">
              Trusted Cleaning Services in Houston
            </span>
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight mb-6"
              data-testid="hero-headline"
            >
              Professional House Cleaning Services in{" "}
              <span className="text-sky-600">Houston, TX</span>
            </h1>
            <p
              className="text-lg md:text-xl text-slate-600 mb-8 leading-relaxed max-w-xl"
              data-testid="hero-subheadline"
            >
              Reliable residential cleaning services tailored to your home and schedule. 
              Experience a cleaner, fresher living space with our professional team.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <Button
                onClick={onBookClick}
                className="bg-sky-600 hover:bg-sky-700 text-white text-lg rounded-full px-8 py-6 font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                data-testid="hero-book-btn"
              >
                Book Cleaning Service
              </Button>
              <Button
                onClick={onQuoteClick}
                variant="outline"
                className="text-lg rounded-full px-8 py-6 font-medium border-2 border-slate-200 hover:bg-slate-50 hover:border-slate-300 transition-all duration-300"
                data-testid="hero-quote-btn"
              >
                Request Free Quote
              </Button>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-4" data-testid="trust-badges">
              {trustBadges.map((badge, index) => (
                <div
                  key={index}
                  className="trust-badge animate-fade-in-up"
                  style={{ animationDelay: `${(index + 1) * 100}ms` }}
                >
                  <CheckCircle2 className="w-5 h-5 text-sky-600 flex-shrink-0" />
                  <span className="text-slate-700">{badge}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative animate-fade-in-up animation-delay-200">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1630699144035-c0f6311ec482?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBicmlnaHQlMjBjbGVhbiUyMGxpdmluZyUyMHJvb20lMjBzcGFya2xpbmd8ZW58MHx8fHwxNzcyNzI3MTQ0fDA&ixlib=rb-4.1.0&q=85"
                alt="Clean modern living room"
                className="rounded-2xl shadow-2xl w-full h-[400px] md:h-[500px] object-cover"
                data-testid="hero-image"
              />
              {/* Floating badge */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-4 hidden md:flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-sky-100 flex items-center justify-center">
                  <span className="text-2xl font-bold text-sky-600">5+</span>
                </div>
                <div>
                  <p className="text-sm text-slate-500">Years of</p>
                  <p className="font-semibold text-slate-900">Experience</p>
                </div>
              </div>
              {/* Another floating badge */}
              <div className="absolute -top-4 -right-4 bg-sky-600 text-white rounded-xl shadow-xl px-4 py-3 hidden md:block">
                <p className="text-sm font-medium">Serving Houston & Surrounding Areas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
